@if (confirmation.title) {
  <div mat-dialog-title>{{confirmation.title}}</div>
}
<div mat-dialog-content [innerHTML]="confirmation.message"></div>
<div mat-dialog-actions align="end">
  <button
    mat-button
    [mat-dialog-close]="false"
    color="primary">
    {{confirmation.noLabel}}
  </button>
  <button
    mat-raised-button
    [mat-dialog-close]="true"
    color="primary"
    cdkFocusInitial>
    {{confirmation.yesLabel}}
  </button>
</div>
